import styled from 'styled-components';

export const Main = styled.main`
  display: flex;
  width: 100dvw;
  height: 100dvh;
  overflow-y: hidden;
`;

export const MenuSection = styled.section<{
  $showMenu: boolean;
  $breakPoint: number;
  $expanded: boolean;
}>`
  z-index: 3;
  left: 0;
  height: 100%;
  transition: width 0.3s ease;
  width: ${({ $expanded }) => ($expanded ? '340px' : '64px')};

  @media only screen and (max-width: ${({ $breakPoint }) => $breakPoint}px) {
    ${({ $showMenu }) => !$showMenu && 'display: none;'}
    position: fixed;
    width: 100vw;
    z-index: 10;
  }
`;

export const PageSection = styled.section<{ $expanded: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: ${({ $expanded }) => `calc(100dvw - ${$expanded ? '340px' : '64px'})`};
  color: ${({ theme }) => theme.neutral_500};
  background-color: ${({ theme }) => theme.neutral_100};
  transition: width 0.3s ease;

  @media only screen and (max-width: 768px) {
    width: 100dvw;
  }
`;
